(function (UX) {
    $body = $('body');

    $body.click(function (e) {
        $('.generic-menu .js--open').removeClass('js--open');
        if ($(e.target).closest('.dropBlock').length === 0) {
            $body.removeAttr('data-effect');
        }
    });
})(UX);
